import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import MDBox from "components/MDBox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable from "examples/Tables/DataTable";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { Snackbar } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
function GenresDisclaimer() {
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const [loading, setLoading] = useState(true); // Loader state
  const [open, setOpen] = useState(false); // Modal state
  const [id,setId] = useState("");

  const [allData, setAllData] = useState([]); // Store all fetched data

  const [filterType, setFilterType] = useState(""); // State for filter by type
  const [openFilter, setOpenFilter] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [formData, setFormData] = useState("");
  const [newFormData, setNewFormData] = useState({type: "", value: "" });
  const userRole = localStorage.getItem("userRole"); // Fetch user role from localStorage
  const [addOpen, setAddOpen] = useState(false); // Add modal state
 const [openSnackbar, setOpenSnackbar] = useState(false);
  const [SnackbarMsg, setSnackbarMsg] = useState("");
  const [deleteBox, setdeleteBox] = useState(false); // Modal state
  const [genreresponseData, setgenreResponseData] = useState([]);



  useEffect(() => {
    fetchData();
  }, []);



  const fetchData = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
  
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return;
      }
  
      const response = await axios.get("https://api.exampladmedia.com/api/genres/getall", {
        headers: {
          Authorization: sessionToken,
        },
      });
  
      const { data } = response.data;
      setAllData(data); // Store all fetched data
      applyFilters(data); // Apply filters to the data
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  const applyFilters = (data) => {
    const filteredRows = [];
    let index = 1;
  
    data.forEach((item) => {
      if (item.value && item.type) {
        // Apply filter logic
        if (!filterType || item.type === filterType) {
          filteredRows.push({
            srNos:index++,
            srNo: item.genType,
            type: item.type,
            text: item.value,
            actions: (
              <MDBox display="flex" justifyContent="center">
                {userRole === "SUPER_ADMIN" && (
                  <>
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() => {
                        setFormData(item.value);
                        handleEdit(item.genType);
                      }}
                    >
                      <EditIcon style={{ color: "green" }} />
                    </IconButton>
                    <IconButton
                      color="secondary"
                      size="small"
                      onClick={() => handleConfirmDelete(item.genType)}
                    >
                      <DeleteIcon style={{ color: "red" }} />
                    </IconButton>
                  </>
                )}
              </MDBox>
            ),
          });
        }
      }
    });
  
    // Define table columns
    const columns = [
      { Header: "srNo", accessor: "srNos", align: "center" },
      { Header: "Type", accessor: "type", align: "center" },
      { Header: "Text", accessor: "text", align: "center" },
      { Header: "Actions", accessor: "actions", align: "center" },
    ];
  
    setTableData({ columns, rows: filteredRows });
    setLoading(false);
    console.log(filteredRows,"filteredRow");
  };


  useEffect(() => {
    fetchData();
  }, []); // Fetch data only once on component mount
  
  useEffect(() => {
    if (allData.length > 0) {
      applyFilters(allData); // Apply filters whenever filterType changes
    }
  }, [filterType]); // Re-apply filters when filterType changes

  
  const handleConfirmDelete = async (item) => {
    
    setSelectedItem(item); // Set the item to be deleted

    setdeleteBox(true)
  }


  
  const handleDelete = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
  
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return; // Exit if sessionToken is not found
      }
      const response = await axios.delete
      (`https://api.exampladmedia.com/api/genres/remove/${selectedItem}`, {
        headers: {
          Authorization: sessionToken,
        },
      });
  
      if (response.status === 200) {
        //setSnackbarMsg(response.data.message);
              setSnackbarMsg("Removed Sucessfully");

        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        fetchData(); // Refresh data after deleting
      }
    } catch (error) {
      if (error.response) {
        // Extract the error message from error.response.data.message
        const errorMessage = error.response.data.message || "An error occurred.";
        setSnackbarMsg(errorMessage);
      } else {
        setSnackbarMsg("An error occurred. Please try again.");
      }
  
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }
  
    setdeleteBox(false); 
  };
  
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  

  const handleEdit = (item) => {
    
    setId(item)
    setOpen(true); // Open modal
  };
  
  const handleAdd = () => {
    setNewFormData({ type: "", text: "" }); // Reset the Add form data
    setAddOpen(true); // Open add modal
  };


  const handleSave = async () => {
    try {
      const sessionToken = localStorage.getItem("sessionToken");
  
      if (!sessionToken) {
        console.error("Session token not found. Please log in again.");
        return; // Exit if sessionToken is not found
      }
  

const payload = {
  value:formData,
};

  
      // Make the API request
      const response = await axios.put(
        `https://api.exampladmedia.com/api/genres/edit/${id}`,
        payload,
        {
          headers: {
            Authorization: sessionToken,
          },
        }
      );
      
      if (response.status === 200) {
        // setSnackbarMsg(response.data.message);
        setSnackbarMsg("Updated Sucessfully");

        setOpenSnackbar(true);
        setTimeout(() => setOpenSnackbar(false), 2000);
        fetchData(); // Refresh data after update
        setOpen(false); // Close modal
      }
      
    } catch (error) {
      // Handle errors gracefully
      if (error.response) {
        const errorMessage = error.response.data.error || "An error occurred.";

        setSnackbarMsg(errorMessage);
      } else {
        setSnackbarMsg("An error occurred. Please try again.");
      }
  
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
    }
  };
  
  const handleClose = () => {
    setOpen(false);
  };
 

const handleAddGenre = async () => {
  try {
    const sessionToken = localStorage.getItem("sessionToken");

    if (!sessionToken) {
      console.error("Session token not found. Please log in again.");
      return;
       // Exit if sessionToken is not found
    }

    // Check and process newFormData
    if (!newFormData || !newFormData.type || !newFormData.text) {
      console.error("Invalid form data");
      setSnackbarMsg("Invalid input data.");
      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
      return;
    }
    const payload = {
      value: newFormData.text,
      type: newFormData.type
  };



    // Make the API request
    const response = await axios.post(
      `https://api.exampladmedia.com/api/genres/create`,
      payload,
      {
        headers: {
          Authorization: sessionToken,
        },
      }
    );

    if (response.status === 200) {
      console.log("Offer updated:",response.data.message);
//setSnackbarMsg(response.data.message);
setSnackbarMsg("Created Sucessfully");

      setOpenSnackbar(true);
      setTimeout(() => setOpenSnackbar(false), 2000);
      setAddOpen(false); // Close modal
      fetchData(); // Refresh data
    }
  } catch (error) {
    // Handle errors gracefully
    if (error.response) {
      setSnackbarMsg(error.response.data.error);
    } else {
      setSnackbarMsg("An error occurred. Please try again.");
    }

    setOpenSnackbar(true);
    setTimeout(() => setOpenSnackbar(false), 2000);
  }
};

  const  handleDeleteCancel = () => {
    setdeleteBox(false)
  }

  return (
    <DashboardLayout>
     <MDBox pt={6} pb={3}>
  <Grid container spacing={3}>
    <Grid item xs={12}>
      <Card>
      <MDBox
  mx={2}
  mt={-3}
  py={3}
  px={2}
  variant="gradient"
  bgColor="info"
  borderRadius="lg"
  coloredShadow="info"
  display="flex"
  justifyContent="space-between"
  alignItems="center"
>
  {/* Add button aligned to the left */}
  <Button
    variant="contained"
    style={{
      backgroundColor: "white",
      color: "grey",
    }}
    onClick={handleAdd}
  >
    Add
  </Button>




  <MDBox display="flex" flexDirection="column">
      {/* Dropdown and Title Container */}
      <MDBox display="flex" alignItems="center" gap={2} p={2}>
        {/* Filter Dropdown with Custom Arrow */}
        <FormControl
          variant="outlined"
          size="small"
          style={{
            marginLeft: "5px",
            minWidth: 120,
            backgroundColor: "white",
            borderRadius: "8px",
            position: "relative", // Ensure positioning for absolute arrow
          }}
        >
          <InputLabel sx={{ color: "black", backgroundColor: "white", paddingX: 1 }}>
            Filter by Type
          </InputLabel>
          <Select
        value={filterType}
        onChange={(e) => setFilterType(e.target.value)}
        label="Filter by Type"
        open={openFilter} // Control open state
        onClose={() => setOpenFilter(false)}
        onOpen={() => setOpenFilter(true)} // Ensure it opens when clicked
        sx={{
          backgroundColor: "white",
          color: "black",
          height: "40px",
          paddingX: 2,
          "& .MuiSelect-select": {
            paddingX: 2, // Ensure padding inside the select box
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "grey", // Customize border color
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "black", // Change border color on hover
          },
        }}
      >
        <MenuItem value="" sx={{ paddingX: 2 }}>All</MenuItem>
        <MenuItem value="GENRE" sx={{ paddingX: 2 }}>Genre</MenuItem>
        <MenuItem value="DISCLAIMER" sx={{ paddingX: 2 }}>Disclaimer</MenuItem>
      </Select>
          {/* <Select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            label="Filter by Type"
            open={openFilter} // Control open state
            onClose={() => setOpenFilter(false)}
            open={openFilter} // Control open state
            onClose={() => setOpenFilter(false)}
            onOpen={() => setOpenFilter(true)}
            sx={{
              backgroundColor: "white",
              color: "black",
              height: "40px",
              paddingX: 2,
              "& .MuiSelect-select": {
                paddingX: 2, // Ensure padding inside the select box
              },
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "grey", // Customize border color
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "black", // Change border color on hover
              },
            }}
          >
            <MenuItem value="" sx={{ paddingX: 2 }}>All</MenuItem>
            <MenuItem value="GENRE" sx={{ paddingX: 2 }}>Genre</MenuItem>
            <MenuItem value="DISCLAIMER" sx={{ paddingX: 2 }}>Disclaimer</MenuItem>
          </Select> */}
          {/* Custom Arrow Button */}
         < IconButton
        onClick={(e) => {
          e.stopPropagation();
          setOpenFilter(true); // Ensure it opens dropdown when clicking button
        }}
        sx={{
          position: "absolute",
          right: "0.5px",
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 2, // Ensure it stays clickable
        }}
      >
        <ArrowDropDownIcon />
      </IconButton>
        </FormControl>
      </MDBox>
    </MDBox>

  {/* Heading centered */}
  <h2 style={{ color: "white", margin: 0, flex: 1, textAlign: "center" }}>
    Genre And Disclaimer
  </h2>
</MDBox>
        <MDBox pt={3} px={3}>
          {loading ? (
            <MDBox
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="300px"
            >
              <CircularProgress color="info" />
            </MDBox>
          ) : (
            <DataTable
              table={tableData}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
          )}
        </MDBox>
      </Card>
    </Grid>
  </Grid>
</MDBox>

      {/* add model */}
      {/* <Dialog open={addOpen} onClose={() => setAddOpen(false)}>
        <DialogTitle>Add Genres /Disclaimer</DialogTitle>
        <DialogContent>
          <div style={{marginTop:'10px'}}></div>
       
          <FormControl variant="outlined" size="small" style={{ minWidth: 120 }}>
  <InputLabel>Filter by Type</InputLabel>
  <Select
    value={filterType}
    onChange={(e) => setFilterType(e.target.value)}
    label="Filter by Type"
  >
    <MenuItem value="">All</MenuItem>
    <MenuItem value="GENRE">Genre</MenuItem>
    <MenuItem value="DISCLAIMER">Disclaimer</MenuItem>
  </Select>
</FormControl>
          <MDBox mb={3}>
            <TextField
              label="Text"
              name="text"
              value={newFormData.text}
              onChange={(e) =>
                setNewFormData({ ...newFormData, text: e.target.value })
              }
              fullWidth
              margin="normal"
            />
          </MDBox>
           
        </DialogContent>
        <DialogActions>
        <Button onClick={handleAddGenre} style={{color:'green'}}>
            Save
          </Button>
          <Button onClick={() => setAddOpen(false)} style={{color:'red'}}>
            Close
          </Button>
         
        </DialogActions>
      </Dialog> */}

<Dialog open={addOpen} onClose={() => setAddOpen(false)}>
        <DialogTitle>Add Genres /Disclaimer</DialogTitle>
        <DialogContent>
          <div style={{marginTop:'10px'}}></div>
        <MDBox mb={2}>
                      <FormControl fullWidth>
                        <InputLabel id="type-label">Type</InputLabel>
                        <Select
                          labelId="type-label"
                          value={newFormData.type}
                          sx={{
                            height: "40px",
                          }}
                          onChange={(e) =>
                            setNewFormData({ ...newFormData, type: e.target.value })
                          }
                          label="Type"
                        >
                          <MenuItem value="GENRE">Genre</MenuItem>
                          <MenuItem value="DISCLAIMER">Disclaimer</MenuItem>
                        </Select>
                      </FormControl>
                    </MDBox>
          <MDBox mb={3}>
            <TextField
              label="Text"
              name="text"
              value={newFormData.text}
              onChange={(e) =>
                setNewFormData({ ...newFormData, text: e.target.value })
              }
              fullWidth
              margin="normal"
            />
          </MDBox>
           
        </DialogContent>
        <DialogActions>
        <Button onClick={handleAddGenre} style={{color:'green'}}>
            Save
          </Button>
          <Button onClick={() => setAddOpen(false)} style={{color:'red'}}>
            Close
          </Button>
         
        </DialogActions>
      </Dialog>
      
{/* edit model */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Edit  Genres/Disclaimer</DialogTitle>
        <DialogContent>
          <MDBox mb={2}>
            <TextField
              label="Text"
              name="text"
              value={formData}
              onChange={(e) => setFormData(e.target.value)}
              fullWidth
              margin="normal"

            />
          </MDBox>
          
        </DialogContent>
        <DialogActions>
        <Button onClick={handleSave} style={{color:'green'}}>
            Save
          </Button>
          <Button onClick={handleClose}  style={{color:'red'}}>
            Close
          </Button>
          
        </DialogActions>
      </Dialog>
       <Snackbar
              open={openSnackbar}
              message={SnackbarMsg}
              autoHideDuration={2000}
              anchorOrigin={{ vertical:"top", horizontal: "right" }}
      
              onClose={() => setOpenSnackbar(false)}
            />

            {/* deletion Dialogbox */}
            <Dialog open={deleteBox} onClose={handleDeleteCancel}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>
            Are you sure you want to delete this {selectedItem?.type || "item"}?
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} style={{ color: "green" }} >
            Confirm
          </Button>
          <Button onClick={handleDeleteCancel}style={{ color: "red" }} >
            Cancel
          </Button>
          
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default GenresDisclaimer;
 